import Content from './Content/Content'
import Options from './Options/Options'


const TermsOfUseConatiner = () => {
    return (
        <>
            <Content />
            <Options />
        </>
    )
}

export default TermsOfUseConatiner